import { useScrollToTop } from "@/helpers/scrollToTop.ts";
import { useEffect } from "react";

export const useReservationFinish = (isReserved: boolean) => {
  const scrollToTop = useScrollToTop();

  useEffect(() => {
    if (isReserved) {
      scrollToTop();
    }
  }, [isReserved, scrollToTop]);
};
